import { render } from "./Socket.vue?vue&type=template&id=08bd9dba&scoped=true"
import script from "./Socket.vue?vue&type=script&lang=js"
export * from "./Socket.vue?vue&type=script&lang=js"

import "./Socket.vue?vue&type=style&index=0&id=08bd9dba&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08bd9dba"]])

export default __exports__